/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Page } from '../../models/page';

export interface ApiMasterPageGetPageByMenuGet$Params {
  menu?: string;
}

export function apiMasterPageGetPageByMenuGet(http: HttpClient, rootUrl: string, params?: ApiMasterPageGetPageByMenuGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Page>> {
  const rb = new RequestBuilder(rootUrl, apiMasterPageGetPageByMenuGet.PATH, 'get');
  if (params) {
    rb.query('menu', params.menu, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Page>;
    })
  );
}

apiMasterPageGetPageByMenuGet.PATH = '/api/Master/Page/GetPageByMenu';
